import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { getAuth } from "../../store/actions/authentication";
import PrivateRoutes from "../../routes/private-routes";
import { AppState } from "../../store";

import { GlobalStyle } from "../../styles/styles";
import { Template, Title } from "./styles";

const Main: React.FC = (props) => {
  const PageTitle: string = useSelector(
    (state: AppState) => state.Authorization.pageTitle
  );
  let params = new URLSearchParams(useLocation().search);
  let token = params.getAll("token")[0];
  const [IsTokenValid, setIsTokenValid] = useState(false);
  useEffect(() => {
    async function callApi(token: string) {
      setIsTokenValid(await getAuth(token));
    }
    if (token) {
      callApi(token);
    }
  }, [token]);

  return (
    <Template>
      {IsTokenValid && (
        <>
          <GlobalStyle />
          <Title>{PageTitle}</Title>
          <PrivateRoutes />
        </>
      )}
    </Template>
  );
};

export default Main;
